// Numero(s) de WhatsApp da vitrine, escritos na tela e linkando pro proprio
// wa.me. Link e texto saem SEMPRE do mesmo dado — o defeito que originou este
// componente foi href e texto serem literais separados em cada pagina.
//
// Lista vazia (carregando ou backend fora) => nao renderiza nada. Some por um
// instante em vez de mostrar numero errado.
import { Fragment } from 'react';
import { useContatoCatalogo } from './useContatoCatalogo';

type Props = {
  className?: string;
  style?: React.CSSProperties;
  separador?: string; // entre numeros, quando houver mais de um
};

export function LinksWhatsapp({ className, style, separador = ' ou ' }: Props) {
  const contatos = useContatoCatalogo();
  if (!contatos.length) return null;

  return (
    <>
      {contatos.map((c, i) => (
        <Fragment key={c.numero}>
          {i > 0 && separador}
          <a
            href={c.link}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
            style={style}
          >
            {c.display}
          </a>
        </Fragment>
      ))}
    </>
  );
}
